// Import Packages
import React, { useEffect } from "react";
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { useTranslation } from "react-i18next";

// Import Material UI
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Dialog, DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Close from "@material-ui/icons/Close";

// Import Pages
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";

// Import Helpers
import { checkTheDifference, addDifference, removeDifference } from '../../../../helpers/helper';

export default function ActiveDirectoryTable({
  action,
  variables,
  setOpen,
  setOpenVariable,
  setDictionaryTable,
  dictionaryTable,
  index,
  setIndex,
  inputName,
  titles = []
}) {
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
  const { t } = useTranslation();

  const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.";

  // control of fields or set field
  useEffect(() => {
    if (action.fields[inputName]) {
      action.fields[inputName].type = "TABLE";
    }
    if (index !== -1) {
      action.fields.keyVariable.value =
        action.fields[inputName].value[index].key;
      action.fields.keyVariable.htmlValue =
        action.fields[inputName].value[index].key;

      action.fields.valueVariable.value =
        action.fields[inputName].value[index].value;
      action.fields.valueVariable.htmlValue =
        action.fields[inputName].value[index].value;
    } else {
      if (action.fields.keyVariable) {
        action.fields.keyVariable = { value: "", htmlValue: "" };
        action.fields.valueVariable = { value: "", htmlValue: "" };
      }
    }
  }, [index, action.fields, inputName]);

  // delete item in array
  function handleDelete() {
    dictionaryTable.splice(index, 1);
    setDictionaryTable(dictionaryTable);
    setOpen(false);
    setIndex(-1);
    changeManagement(dictionaryTable);
    //setSaveAvailable(true);
  }

  //update item in array
  function handleUpdate() {
    if (action.fields.keyVariable?.value && action.fields.valueVariable?.value) {
      dictionaryTable[index].key = action.fields.keyVariable.value;

      dictionaryTable[index].value = action.fields.valueVariable.value;
      setOpen(false);
      setIndex(-1);
      changeManagement(dictionaryTable);
    }
  }
  // added variable in array
  function handleAdd() {

    if (action.fields.keyVariable?.value && action.fields.valueVariable?.value) {
      let newTable = JSON.parse(JSON.stringify(dictionaryTable))
      newTable.push({
        key: action.fields.keyVariable.value,
        value: action.fields.valueVariable.value,
      })
      // setDictionaryTable((oldArr) => [
      //   ...oldArr,
      //   {
      //     key: action.fields.keyVariable.value,
      //     value: action.fields.valueVariable.value,
      //   },
      // ]);
      changeManagement(newTable);
      setDictionaryTable(newTable);
      setOpen(false);
      setIndex(-1);
    }
  }

  function changeManagement(newTable) {
    const field = initialActionsData[action.id]?.fields['customAttributes'];
    const oldValue = !field ? undefined : field.value;
    const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
    if (!oldValue) {
      addDifference(cfTemp, action, 'customAttributes', setChangeFields, setSaveAvailable)
    } else {
      if (checkTheDifference(newTable, oldValue, ["keyVariable", "valueVariable"])) {
        addDifference(cfTemp, action, 'customAttributes', setChangeFields, setSaveAvailable)
      } else {
        removeDifference(cfTemp, action, 'customAttributes', setChangeFields, setSaveAvailable)
      }
    }
  }
  // select type


  // close modal
  function handleClose() {
    setOpen(false);
    setIndex(-1);
  }
  return (
    <Dialog id="autom-addNew-modal" data-test="autom-add-new" open={true}>
      <DialogTitle id="alert-dialog-title">
        <div className="modal-title">
          Custom Attributes
          <Button data-test="cancelautom-button" onClick={handleClose}>
            <Close />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ width: "400px" }}>
          <div className="form-element">
            {titles.length > 0 ? titles[0] : "User"}
            <TextInput
              action={action}
              inputName="keyVariable"
              isRequired={false}
              setOpenVariable={setOpenVariable}
              variables={variables}
              ignoreSave={true}
            />
          </div>
          <div className="form-element">
            {titles.length > 0 ? titles[1] : "Distinguishedname"}
            <TextInput
              action={action}
              inputName="valueVariable"
              isRequired={false}
              setOpenVariable={setOpenVariable}
              variables={variables}
              ignoreSave={true}
            />
            <small className='conf-field-desc'>{t(label + "NOT-SET-DESC")}</small>
            <small className='conf-field-desc'>{t(label + "CUSTOM-ATTRIBUTE-VALUE-DESC")}</small>
          </div>
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: "space-between",
          padding: "8px 24px 16px 24px",
        }}
      >
        {index === -1 ? (
          <>
            <Button variant="outlined"
              style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="outlined"
              style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleAdd}>
              Add
            </Button>
          </>
        ) : (
          <>
            <Button variant="outlined"
              style={{ float: "left", backgroundColor: "#D75E5E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleDelete}>
              Delete
            </Button>
            <Button variant="outlined"
              style={{ float: "right", backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "45%", border: "none" }}
              onClick={handleUpdate}>
              Edit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}
